import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import FullScreenSpinner from '../components/FullScreenSpinner';

// Gate for the auth screens: a signed-in user visiting /login or /register is
// redirected to "/" — the editor-first resolver drops them straight into the work.
export default function PublicRoute({ children }: { children: ReactNode }) {
  const { me, loading } = useAuth();

  if (loading) return <FullScreenSpinner />;
  if (me) return <Navigate to="/" replace />;
  return <>{children}</>;
}
